import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
// import { orderApi } from "../../app/slices/orderSlice";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { mandateApi } from "../../app/slices/mandateSlice";
import { Box, LinearProgress } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material"; // Import the copy icon from MUI


export default function Mandate() {
  const dispatch = useDispatch();

  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(mandateApi(queryParams));
  }, [dispatch, queryParams]);

  // useEffect(() => {
  //   dispatch(mandateApi());
  // }, [dispatch]);

  const sliceResponse = useSelector((state) => state.mandate?.mandate?.data);
  const stateLoading = useSelector(
    (state) => state.mandate.loading
  );

  // loading={stateLoading}
  // Memoize API dispatch to avoid re-fetching
  const fetchData = useCallback(() => {
    if (!sliceResponse) {
      dispatch(mandateApi(queryParams));
    }
  }, [dispatch, sliceResponse, queryParams]);

  // Use useEffect to only call API if data is not in the store
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerRefNo", {
      header: "CustomerRefNo",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerName}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partner_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partner_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.partnerName}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("proposal_no", {
      header: "proposal_no",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.proposal_no);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.proposal_no}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.proposal_no}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("proposal_id", {
      header: "proposal_id",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.proposal_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.proposal_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.proposal_id}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("sip_status", {
      header: "sip_status",
      size: 150,
      Cell: (cell) => cell.row.original?.sip_status,
    }),
    columnHelper.accessor("merchantTransactionId", {
      header: "merchantTransactionId",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId
          );
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("payment_link", {
      header: "payment_link",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.payment_link);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.payment_link}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("subReferenceId", {
      header: "subReferenceId",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.subReferenceId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.subReferenceId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.subReferenceId}
            </span>
          </Tooltip>
        );
      },
    }),
  ];

  return (
    <>
     {/*  */}
      <>
        <DateSearchComponent onSearch={handleSearch} />
        <Box mt={2} >

          <CustomTable columns={columns} data={sliceResponse} loading={stateLoading} permissionKey="Mandates"/>
        </Box>
      </>

    </>
  );
}
